import React, { useState } from "react";
import { useSelector } from "react-redux";
import Popup from "../../../../shared/components/ui/popup/Popup";
import HeaderPopup from "../../../../shared/components/ui/popup/headerPopup/HeaderPopup";
import ContentPopup from "../../../../shared/components/ui/popup/contentPopup/ContentPopup";
import PrimaryBtn from "../../../../shared/components/ui/buttons/PrimaryBtn";
import SecondaryBtn from "../../../../shared/components/ui/buttons/SecondaryBtn";
import UserSearchField from "./userSearchField/UserSearchField";
import classes from "./AddPermissionPopup.module.css";

const AddPermissionPopup = ({ onClose, onAdd }) => {
    const { texts } = useSelector((state) => state.translate);
    const [selectedUser, setSelectedUser] = useState(null);

    const handleAdd = () => {
        if (!selectedUser) return;
        onAdd(selectedUser);
        onClose();
    };

    return (
        <Popup
            close={onClose}
            accessibilityDescription={texts.addPermissionHolder}
            dropClass={classes.PopupDrop}
        >
            <HeaderPopup accessibilityDescription={texts.addPermissionHolder}>
                <p className={classes.HeaderTitle}>{texts.addPermissionHolder}</p>
            </HeaderPopup>

            <ContentPopup className={classes.Body} scrollDropClass={classes.Scroll}>
                <p className={classes.Desc}>
                    <span className={classes.DescMain}>{texts.selectUsersForPermission}</span>
                    <span className={classes.DescSub}>{texts.allUsersHaveSamePermissions}</span>
                </p>

                <UserSearchField
                    selectedUser={selectedUser}
                    onSelect={setSelectedUser}
                />
            </ContentPopup>

            <div className={classes.Footer}>

                <SecondaryBtn
                    dropClass={classes.CancelBtn}
                    onClick={onClose}
                    color="var(--color-primary-button)"
                >
                    {texts.cancel}
                </SecondaryBtn>
                <PrimaryBtn
                    dropClass={`${classes.AddBtn} ${!selectedUser ? classes.AddBtnDisabled : ""}`}
                    onClick={selectedUser ? handleAdd : undefined}
                    disabled={!selectedUser}
                >
                    {texts.add}
                </PrimaryBtn>
            </div>
        </Popup>
    );
};

export default AddPermissionPopup;
